import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISSED = "chambers-install-dismissed";

export const InstallPrompt = () => {
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    if (window.localStorage.getItem(DISMISSED)) return undefined;
    const onPrompt = (event) => {
      event.preventDefault();
      setPrompt(event);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!prompt) return null;

  const dismiss = () => {
    window.localStorage.setItem(DISMISSED, "1");
    setPrompt(null);
  };

  const install = async () => {
    prompt.prompt();
    await prompt.userChoice;
    dismiss();
  };

  return (
    <div
      className="no-print flex items-center gap-3 border-b border-slate-200 bg-white px-4 py-2.5"
      data-testid="install-prompt"
    >
      <Download className="h-4 w-4 shrink-0 text-brand-terracotta" strokeWidth={1.8} />
      <p className="min-w-0 flex-1 text-[12px] leading-snug text-slate-600">
        Keep the ledger on your home screen.
      </p>
      <button
        type="button"
        onClick={install}
        data-testid="install-app-button"
        className="shrink-0 bg-slate-900 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.1em] text-white transition-colors duration-150 hover:bg-slate-800"
      >
        Install
      </button>
      <button
        type="button"
        onClick={dismiss}
        data-testid="dismiss-install-button"
        className="shrink-0 text-slate-400 transition-colors duration-150 hover:text-slate-900"
      >
        <X className="h-3.5 w-3.5" strokeWidth={2} />
      </button>
    </div>
  );
};
